import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'project-admin-knowledge-index',
    template: require('./project.admin.knowledge-index.html'),
})
export class ProjectAdminKnowledgeIndexComponent implements OnInit {
    @Input() project: any;
    @Input() isProjectAdmin: any;

    constructor(private titleService: Title) {}

    ngOnInit(): void {
        this.titleService.setTitle('Knowledge Index');
    }
}
